/* projects/shared/src/lib/components/sidemenu/sidemenu.component.css */
.container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
mat-sidenav {
  width: 250px;
}
.circle {
  border-radius: 50%;
}
.with-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}
.no-shadow {
  box-shadow: none !important;
}
::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}
.bottom-to-top {
  border: 0px;
  border-right: 1px;
  border-style: solid;
  border-image:
    linear-gradient(
      to top,
      #c1c1c1,
      rgba(0, 0, 0, 0)) 1 100%;
}
.ptr-10 {
  padding-right: 10px;
}
.ptt-10 {
  padding-top: 10px;
}
.logo {
  height: 40px;
  margin: 5px 0 5px 0;
  max-width: 100%;
}
.sidemenu {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.sidemenu-footer {
  margin-top: auto;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.bottom-img {
  max-width: 100%;
  height: auto;
  flex-shrink: 0;
}
.logo-bkg {
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
.version {
  color: white;
  width: 100%;
  text-align: center;
  padding-top: 10px;
  font-size: x-small;
}
/*# sourceMappingURL=sidemenu.component.css.map */
